import 'styles/Gallery.less'
import React, { Component, PropTypes } from 'react'
import { Router, Route, Link } from 'react-router'
import { connect } from 'react-redux'
import assets from 'modules/assets'
import photo from '../../../datas/photos/index.json'
import * as actions from 'actions'
import classNames from 'classnames'
import Image from 'components/Gallery/Image'
import GallerySplashSection from 'components/Gallery/GallerySplashSection'

class Splash extends Component {
  constructor(props) {
    // const SPLASH_ALBUM_NAME = 'camp-2016-splash'
    super(props)
    this.state = {
      height: 0,
      width: 0,
      initialSwipeActive: true
    }
    this.hasMouse = false
  }
  updateDimensions() {
    this.setState({
      height: window.innerHeight,
      width: window.innerWidth
    })
  }
  componentDidMount() {
    this.props.dispatch(actions.token.toggleHeader(true))
    this.updateDimensions()
    window.addEventListener('resize', this.updateDimensions.bind(this))
  }
  componentWillUnmount() {
    this.props.dispatch(actions.token.toggleHeader(false))
  }
  navigate(year) {
    this.props.router.push(`/gallery/${year}`)
  }
  onMouseMove() {
    if (this.state.initialSwipeActive) {
      this.setState({
        initialSwipeActive: false
      })
    }
  }
  render() {
  	return (
  		<div className='camp-2016-splash' onMouseMove={this.onMouseMove.bind(this)}>
        <GallerySplashSection initialSwipe={{active: this.state.initialSwipeActive, delay: 3100}} windowWidth={this.state.width} windowHeight={this.state.height} text='2019' year='2019' onClick={this.navigate.bind(this, 2019)}/>
        <GallerySplashSection initialSwipe={{active: this.state.initialSwipeActive, delay: 2021}} windowWidth={this.state.width} windowHeight={this.state.height} text='2018' year='2018' onClick={this.navigate.bind(this, 2018)}/>
        <GallerySplashSection initialSwipe={{active: this.state.initialSwipeActive, delay: 1283}} windowWidth={this.state.width} windowHeight={this.state.height} text='2017' year='2017' onClick={this.navigate.bind(this, 2017)}/>
        <GallerySplashSection initialSwipe={{active: this.state.initialSwipeActive, delay: 2583}} windowWidth={this.state.width} windowHeight={this.state.height} text='2016' year='2016' onClick={this.navigate.bind(this, 2016)}/>
        <div className="gallery-splash-text">Gakko</div>
  		</div>
  	)
	}
}

Splash.contextTypes = {
}
Splash.propTypes = {
}
function mapStateToProps(state, ownProps) {
  return {
    location:ownProps.location
  }
}

export default connect(mapStateToProps)(Splash)



// WEBPACK FOOTER //
// ./src/components/Gallery/GallerySplash.js